// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/imputation_policy_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { ImputationPolicyService } from "./imputation_policy_service_pb";

/**
 * GetImputationPolicy returns the current organization's policy. When no row
 * has been saved yet, the spec defaults are returned (demand = PREV_TIME per
 * AC-002, generation = [PLAN_VALUE, PREV_TIME] per AC-008) with updated_at
 * unset.
 *
 * @generated from rpc bffuser.v1.ImputationPolicyService.GetImputationPolicy
 */
export const getImputationPolicy = ImputationPolicyService.method.getImputationPolicy;

/**
 * UpdateImputationPolicy applies an update with last-writer-wins semantics
 * (spec Discussion 後勝ち; the screen saves each change immediately).
 *
 * update_mask.paths selects which fields are written: only the named fields
 * are persisted, and fields not named keep their currently saved value.
 *
 * The client must still populate EVERY field of policy, because the payload
 * carries strict protovalidate rules (enum not_in [0], repeated min_items)
 * that a true partial message would fail — see ImputationPolicy in
 * imputation_policy_model.proto and TODO(#556). Values of unnamed fields are
 * ignored: they may be stale, and writing them back would clobber another
 * user's concurrent edit of a different field.
 *
 * The BFF handler passes the update_mask through to the backend without
 * reconstruction.
 *
 * @generated from rpc bffuser.v1.ImputationPolicyService.UpdateImputationPolicy
 */
export const updateImputationPolicy = ImputationPolicyService.method.updateImputationPolicy;
